import { getCookie, setCookie, removeCookie } from './cookie';
import { trackError, trackEvent } from './omega';
import url from './url';

/**
 * 集群环境
 */
const ENV = {
    /**
     * 小流量
     */
    SMALLFLOW: 'smallflow',
    /**
     * 线上
     */
    ONLINE: 'online'
};

const HINT_FALG = '1';

/**
 * 默认配置
 */
const defaultConfig = {
    isHit: false, // 是否命中小流量
    flag: '', // 业务线标示, cookie名称
    onEnvChange // 切换环境时回调方法 (curEnv: string, nextEnv: string) => void
};

/**
 * 当前环境
 */
let env = '';

/**
 * 根据是否命中值处理cookie
 * @param {boolean} isHitResult 命中小流量结果
 * @param {string} flag 小流量标示
 * @return {boolean} 环境是否发生变化
 */
function processCookie(isHitResult: boolean, flag: string) {
    // 获取小流量cookie
    const smallFlowCookie = getCookie(flag);

    if (isHitResult) {
        // 命中小流量，且没有小流量cookie，则需要种cookie并刷新页面，进入小流量页面
        if (!smallFlowCookie) {
            setCookie(flag, HINT_FALG);

            return true;
        }
    } else {
        // 没命中小流量，但有小流量cookie，则需要删除cookie，进入线上页面
        if (smallFlowCookie) {
            removeCookie(flag);

            return true;
        }

        return false;
    }
}

/**
 * 切换环境时回调方法
 * 默认刷新页面
 */
function onEnvChange() {
    window.location.reload();
}

/**
 * 获取当前的集群环境
 * @return {string} 当前集群环境
 */
function getEnv() {
    if (!env) {
        console.error('[SMALLFLOW] ERROR: 请先初始化小流量组件再调用方法');

        return;
    }

    return env;
}

/**
 * 初始化小流量配置
 * @param {boolean} isHit 是否命中小流量
 * @param {string} flag cookie名称
 * @param {string} onEnvChange 切换环境时回调方法
 */
function init(opt: { isHit: boolean; flag: string; onEnvChange?: (curEnv: string, nextEnv: string) => void }) {
    return new Promise((resolve, reject) => {
        const config = {
            ...defaultConfig,
            ...opt
        };

        const { isHit, flag, onEnvChange } = config;

        if (!flag) {
            console.error('[SMALLFLOW] ERROR: 业务小流量cookie不能为空字符串');

            return resolve(false);
        }

        // 通过小流量cookie判断当前环境，有则当前在小流量环境，否则在线上环境
        env = getCookie(flag) ? ENV.SMALLFLOW : ENV.ONLINE;
        // 获取是否命中小流量的结果
        const isHitResult = isHit;

        // 保证命中结果为布尔值
        if (typeof isHitResult !== 'boolean') {
            console.error('[SMALLFLOW] ERROR: 传入isHit的值或者函数的返回值不为布尔值');

            return resolve(false);
        }

        // 根据命中值处理cookie，返回当前环境是否发生变化
        const isRefresh = processCookie(isHitResult, flag);

        // 环境发生变化时，由线上切换到小流量，或者小流量切换到线上，执行onEnvChange方法
        if (isRefresh) {
            const curEnv = env;

            const nextEnv = curEnv === ENV.SMALLFLOW ? ENV.ONLINE : ENV.SMALLFLOW;

            onEnvChange && onEnvChange(curEnv, nextEnv);
        }

        return resolve(isRefresh);
    });
}

// 请求小流量接口
export const smallFlowInit = () => {
    // 小流量开关名称
    const SMALL_FLOW_NAME = 'fintech_marketing_small_flow';
    const URL_SMALL_FLOW_KEY = 'ADV_SMALL_FLOW';
    const URL_SMALL_FLOW_VALUE = '1';

    const isHit = url.get(URL_SMALL_FLOW_KEY) === URL_SMALL_FLOW_VALUE;

    init({
        isHit: isHit,
        flag: SMALL_FLOW_NAME
    })
        .then(() => {
            const currentEnv = getEnv();

            if (currentEnv === ENV.SMALLFLOW) {
                trackEvent('feintech_marketing_get_small_flow_show', { env: currentEnv });
            }
        })
        .catch((err) => {
            trackError('feintech_marketing_get_small_flow_error', err?.message, err);
        });
};
